/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions  */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import Slider from 'react-slick';
import uniqueId from 'uniqid';

import Image from '../Image';
import Modal from '../Modal';

import { ProductFormContext } from '../../context/product-form-context';

const ns = `pdp-image-slider`;

const Arrow = props => {
	const {
		className, onClick,
	} = props;

	return (
		<button
			className={className}
			onClick={onClick}
			aria-label="Left slide navigation arrow"
		>
			<svg width={'19'} height={'32'} viewBox={'0 0 19 32'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
				<path fillRule={'evenodd'} clipRule={'evenodd'} d={'M4.09047 1.20515C3.36002 0.525875 2.22903 0.525876 1.49858 1.20515C0.689124 1.95789 0.689126 3.23957 1.49858 3.99231L11.2611 13.0708C12.9625 14.653 12.9625 17.347 11.2611 18.9292L1.49858 28.0077C0.689124 28.7604 0.689123 30.0421 1.49858 30.7949C2.22903 31.4741 3.36002 31.4741 4.09047 30.7949L16.8501 18.9292C18.5515 17.347 18.5515 14.653 16.8501 13.0708L4.09047 1.20515Z'} fill={'#003C77'} />
			</svg>
		</button>
	);
};

const ArrowAlt = props => {
	const {
		className,
		onClick,
		id,
	} = props;

	return (
		<button
			className={className}
			id={id}
			onClick={onClick}
			aria-label="Right slide navigation arrow"
		>
			<svg width={'40'} height={'40'} viewBox={'0 0 40 40'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
				<rect width={'40'} height={'40'} rx={'20'} fill={'#F5F6F7'} />
				<path fillRule={'evenodd'} clipRule={'evenodd'} d={'M17.2074 9.43235C16.6857 8.94716 15.8778 8.94716 15.3561 9.43235C14.7779 9.97002 14.7779 10.8855 15.3561 11.4232L22.3293 17.9078C23.5446 19.038 23.5446 20.9622 22.3293 22.0924L15.3561 28.577C14.7779 29.1147 14.7779 30.0302 15.3561 30.5679C15.8778 31.0531 16.6857 31.0531 17.2074 30.5679L26.3215 22.0924C27.5367 20.9622 27.5367 19.038 26.3215 17.9078L17.2074 9.43235Z'} fill={'#003C77'} />
			</svg>
		</button>
	);
};

const PDPImageZoomSlider = ({images, hasVariants}) => {
	const [isZoomed, setIsZoomed] = useState(false);

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ ns }--zoomed`]: isZoomed,
	});

	const {
		variant,
	} = React.useContext(ProductFormContext);

	const sliderRef = useRef();
	const zoomSliderRef = useRef();
	const [modifiedImages, setModifiedImages] = useState([...images]);
	const [sliderReady, setSliderReady] = useState(false);
	const [currentSlide, setCurrentSlide] = useState();
	const [currentInnerHeight, setCurrentInnerHeight] = useState();
	const [isClicked, setIsClicked] = useState(false);

	const productImages = [...images];
	const hasImages = images.length > 0;

	let currentPan = 0;
	let lastX;

	const setSliderChanges = current => {
		sliderRef.current.slickGoTo(current);
		const allSections = document.querySelectorAll(`.${ ns }__slide-section`);
		allSections.forEach(section => {
			// eslint-disable-next-line no-param-reassign
			section.style.transform = 'translate(0, 0)';
		});
	};

	const handleZoom = () => {
		if (typeof window !== `undefined`) {
			window.scrollTo({ top: 0, behavior: 'smooth' });

			// This exist to solve a bug that is only
			// experinced in in-app browers.
			// the css to not
			window.scrollTo(0, -50);
		}

		setTimeout(() => {
			setIsZoomed(state => { return !state; });
		}, 100);
	};

	const imagePan = e => {
		const currentX = e.type === 'mousemove' ? e.pageX : e.changedTouches[0].clientX;
		const maxPan = (e.target.width - window.innerWidth) / 2;
		const parent = e.target.parentElement;

		if (lastX > currentX) {
			if (currentPan >= -maxPan) {
				currentPan -= 10;
				parent.style.transform = `translate(${ currentPan }px, 0)`;
			}
		}

		if (lastX < currentX) {
			if (currentPan <= maxPan) {
				currentPan += 10;
				parent.style.transform = `translate(${ currentPan }px, 0)`;
			}
		}

		lastX = currentX;
	};

	const mouseDown = () => {
		setIsClicked(true);
	};

	const mouseUp = () => {
		setIsClicked(false);
	};

	const mouseMove = e => {
		if (isClicked) {
			imagePan(e);
		}
	};

	const handleOutsideClick = e => {
		const ele = e.target;
		if (!ele.closest('#product-image')) {
			setIsZoomed(false);
		}
	};

	useEffect(() => {
		const urlParameters	= new URLSearchParams(window.location.search);
		const urlVariantId = urlParameters.get('variant');

		// check if the selected variant has the 'variant_specific_images' metafield
		const doVariantSpecificImagesExist = variant?.metafields?.find(elem => { return elem.key === 'variant_specific_images'; });

		if (hasVariants && variant?.image) {
			productImages.splice(2, 0, {...variant?.image, variantImage: true});
			setModifiedImages([...productImages]);
			setSliderReady(true);
		}

		if (doVariantSpecificImagesExist !== undefined) {
			// we parse the JSON because we recive it as a string
			const variantSpecificImages = JSON.parse(doVariantSpecificImagesExist.value);
			// we loop through all images in the array and append that value to the
			// productImage array
			variantSpecificImages.images?.forEach(image => {
				productImages.push(image);
			});

			setModifiedImages([...productImages]);
		}

		const slickSlider = sliderRef.current;
		slickSlider.slickGoTo(2, true);
		setCurrentSlide(2);

		// This re-runs the slickGotTo() method 700ms after
		// the initial one because slick becomes unresponsive
		// when a variant has more images than another variant.
		// The slider becomes responsive again after an unknown amount
		// of time.
		if (sliderReady || urlVariantId) {
			setTimeout(() => {
				slickSlider.slickGoTo(2, true);
				setCurrentSlide(2);
			}, '700');
		}
	}, [variant]); // eslint-disable-line

	useEffect(() => {
		setCurrentInnerHeight(window.innerHeight);
		function handleResize() {
			setCurrentInnerHeight(window.innerHeight);
		}

		window.addEventListener('resize', handleResize);

		return () => { return window.removeEventListener('resize', handleResize); };
	}, []);

	const settings = {
		dots: true,
		arrows: true,
		speed: 500,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		nextArrow: <Arrow direction={'next'} sliderLength={images.length} />,
		prevArrow: <Arrow direction={'prev'} sliderLength={images.length} />,
		afterChange: current => { return setCurrentSlide(current); },
		responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
				},
			},
		],
	};

	const zoomSliderSettings = {
		dots: false,
		arrows: true,
		speed: 500,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		swipe: false,
		nextArrow: <ArrowAlt direction={'next'} sliderLength={images.length} id={`${ ns }__zoom-button--next`} />,
		prevArrow: <ArrowAlt direction={'prev'} sliderLength={images.length} id={`${ ns }__zoom-button--prev`} />,
		initialSlide: currentSlide,
		afterChange: current => { return setSliderChanges(current); },
	};

	return (
		<div className={`${ rootClassnames }`}>
			{hasImages ? (
				<>
					<Slider ref={sliderRef} {...settings}>
						{modifiedImages.map((slide, index) => {
							return (
								<button
									className={`${ ns }__slide`}
									key={uniqueId('nn')}
									onClick={handleZoom}
									aria-label={`Zoom product image ${index + 1}`}
								>
									<Image sourceUrl={slide.src || slide.originalSrc} altText={slide.altText || `Product Image ${ index }`} />
								</button>
							);
						})}
					</Slider>
					<Modal
						modifier={'image-zoom'}
						isOpen={isZoomed}
						onRequestClose={handleZoom}
					>
						<Slider ref={zoomSliderRef} {...zoomSliderSettings}>
							{modifiedImages.map((slide, index) => {
								return (
									<div className={`${ ns }__slide`} key={uniqueId('nn')}>
										<div className={`${ ns }__slide-container`} onClick={handleOutsideClick}>
											<section className={`${ ns }__slide-section`}>
												<img
													id={'product-image'}
													style={{height: currentInnerHeight}}
													className={isClicked ? 'is-clicked' : ''}
													src={slide.src || slide.originalSrc}
													alt={slide.altText || `Product Image ${ index }`}
													onTouchMove={imagePan}
													onMouseDown={mouseDown}
													onMouseUp={mouseUp}
													onMouseMove={mouseMove}
													onMouseLeave={mouseUp}
												/>
											</section>
										</div>
									</div>
								);
							})}
						</Slider>
					</Modal>
				</>
			) : (
				<div className={`${ ns }__no-image`}>No Preview image</div>
			)}
		</div>
	);
};

export default PDPImageZoomSlider;
